import {
  CHAINE_GET_SUCCES,
  CHAINE_GET_ECHEC,
  CHAINE_UPDATE_SUCCES,
  CHAINE_UPDATE_ECHEC,
} from "../constantes/chaineOrclConstantes";

export const chaineGetReducer = (state = { chaine: {} }, action) => {
  switch (action.type) {
    case CHAINE_GET_SUCCES:
      return {
        chaine: action.payload,
      };
    case CHAINE_GET_ECHEC:
      return {
        erreur: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export const chaineUpdateReducer = (state = { chaine: {} }, action) => {
  switch (action.type) {
    case CHAINE_UPDATE_SUCCES:
      return {
        chaine: action.payload,
      };
    case CHAINE_UPDATE_ECHEC:
      return {
        erreur: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
